import {AfterViewInit, Component, HostListener, Input, OnInit} from '@angular/core';
import {DomSanitizer, SafeStyle} from '@angular/platform-browser';
import {TabbingService} from '../../../tabbing/services/tabbing.service';
import {ExternalTooltip} from '../../data/externalTooltip';

@Component({
  selector: 'app-tooltip-content',
  templateUrl: './tooltip-content.component.html',
  styleUrls: ['./tooltip-content.component.css']
})
export class TooltipContentComponent implements OnInit, AfterViewInit {

  @Input() tooltip: ExternalTooltip;
  positionStyle: SafeStyle;

  constructor(public domSanitizer: DomSanitizer,
              public tabbingService: TabbingService,) {
    this.domSanitizer = domSanitizer;
  }

  ngOnInit() {
  }

  ngAfterViewInit(): void {
    var rect = this.tooltip.ref.nativeElement.getBoundingClientRect();
    var style = 'position:fixed;' +
      'top:' + (rect.top - 40) + 'px;' +
      'left:' + rect.left + 'px;';
    this.positionStyle = this.domSanitizer.bypassSecurityTrustStyle(style);
  }

  @HostListener('window:resize')
  onWindowResize(): void {
    // update position based on `ref`
  }


}
